export const waGratis1 = [
  {
    id: 1,
    text: 'Customer mungkin <b>lupa menyiapkan</b> atau <b>membawa uang</b> saat melakukan pembayaran COD.',
    check: false,
  },
  {
    id: 2,
    text: 'Customer yang tidak menerima <b>informasi paket</b> mungkin <b>beralih</b> ke <b>penjual lain.</b>',
    check: false,
  },
  {
    id: 3,
    text: '<b>Pusing</b> dan <b>ribet</b> ketika update notif <b>manual</b> ke banyak customer.',
    check: false,
  },
]
export const waGratis2 = [
  {
    id: 1,
    text: 'Tanpa <b>broadcast,</b> tingkat <b>order ulang</b> rendah.',
    check: false,
  },
  {
    id: 2,
    text: '<b>Ribet,</b> untuk <b>chat manual</b> ke banyak customer.',
    check: false,
  },
]
export const waPremium1 = [
  {
    id: 1,
    text: '<b>Notifikasi</b> ke customer <b>otomatis</b> saat paket sampai kota customer.',
    check: true,
  },
  {
    id: 2,
    text: '<b>Kirim resi otomatis</b>  ke customer saat produk sudah di pickup.',
    check: true,
  },
  {
    id: 3,
    text: 'Buat <b>template pesan</b> sesuai <b>kebutuhanmu.</b>',
    check: true,
  },
]

export const waPremium2 = [
  {
    id: 1,
    text: 'Tingkat <b>penjualan</b> dan <b>order ulang</b> dengan <b>broadcast.</b>',
    check: true,
  },
  {
    id: 2,
    text: 'Kirim banyak pesan <b>dengan 1x klik.</b>',
    check: true,
  },
]

export const pointModalPricing = [
  [
    {
      title: 'Benefit',
    },

    {
      id: 1,
      point: 'Notifikasi Pengiriman - Komship',
      active: true,
    },
    {
      id: 2,
      point: '3 Nomor bisa ditautkan',
      active: true,
    },
    {
      id: 3,
      point: 'Broadcast - Komchat',
      active: false,
    },
    {
      id: 4,
      point: 'Rotator Nomor Pengirim',
      active: false,
    },
    {
      id: 5,
      point: 'Spintax Text',
      active: false,
    },
    {
      id: 6,
      point: 'Smart Sender Broadcast',
      active: false,
    },

  ],
  [
    {
      title: 'What`s included',
    },
    {
      id: 1,
      point: 'Notifikasi Pengiriman - Komship',
      active: true,
    },
    {
      id: 2,
      point: 'Unlimited Broadcast',
      active: true,
    },
    {
      id: 3,
      point: 'Rotator Nomor Pengirim',
      active: true,
    },
    {
      id: 4,
      point: 'Unlimited Kontak',
      active: true,
    },
    {
      id: 5,
      point: 'Spintax Text (Generate AI)',
      active: true,
    },
    {
      id: 6,
      point: 'Smart Sender Broadcast',
      active: true,
    },
  ],
  [
    {
      title: 'What`s included',
    },
    {
      id: 1,
      point: 'Komchat Basic',
      active: true,
    },
    {
      id: 2,
      point: 'Auto Save CRM',
      active: true,
    },
    {
      id: 3,
      point: '1 Member Only',
      active: true,
    },
    {
      id: 4,
      point: 'Rotator Nomor Pengirim',
      active: true,
    },
    {
      id: 5,
      point: '1,000 Percakapan Free (1 Bulan)',
      active: true,
    },
    {
      id: 6,
      point: 'Free Chat (72 Jam)',
      active: true,
    },
  ],
]

export const cardPricing = [
  {
    idPackage: 1,
    levelPackage: 1,
    name: 'Starter',
    subTitle: `
      Nikmati fitur tanpa biaya, untuk user
      <span class="flex items-center gap-1">
        kategori
        <span><img width="13" src="https://storage.googleapis.com/komerce/assets/svg/Saudagar.svg" alt=""></span> 
        <span class="text-xs text-black">Saudagar</span>
        <span class="flex items-center gap-1">
          dan <span><img width="13" src="https://storage.googleapis.com/komerce/assets/icons/badge_juragan.svg" alt=""></span>
          <span class="text-xs text-black"> Juragan</span>
        </span>
      </span>
      <span>Pelajari Benefitnya <a
                  href="https://bantuan.komerce.id/id/article/status-membership-komship-dan-manfaatnya-oavgab/?bust=1686796830496"
                  target="_blank"
                  style="color: #08A0F7; text-decoration: underline;"
                >disini</a></span>
    `,
    price: '49.000',
    point: [
      { text: 'Notifikasi Pengiriman - Komship', active: true },
      { text: '3 Nomor bisa ditautkan', active: true },
      { text: 'Broadcast - Komchat', active: false },
      { text: 'Rotator Nomor Pengirim', active: false },
      { text: 'Spintax Text', active: false },
      { text: 'Smart Sender Broadcast', active: false },
    ],
  },
  {
    idPackage: 5,
    levelPackage: 2,
    name: 'Basic',
    subTitle: 'Layanan AI siap membantu kapan saja, Broadcast unlimited langsung dari WhatsApp Bisnis Anda',
    price: '79.000',
    point: [
      { text: '<span class="flex gap-1"><span class="bg-gradient-to-r from-[#F8320A] via-[#00C6A3] to-[#310086] bg-clip-text text-transparent">AI Customer Service </span><img alt="logo-starts"  src="https://storage.googleapis.com/komerce/assets/LP-Komchat/stars-solors.svg"/></span>', active: true },
      { text: '<span>Semua fitur <span class="text-primary font-semibold">Komchat Starter</span></span>', active: true },
      { text: 'Broadcast Unlimited', active: true },
      { text: 'Rotator Nomor Pengirim', active: true },
      { text: 'Unlimited Kontak', active: true },
      { text: 'Spintax Text (Generate AI)', active: true },
      { text: 'Broadcast Gambar', active: true },
      { text: 'Bantuan Pemulihan Akun Banned Meta', active: true },
    ],
  },
  {
    idPackage: 9,
    levelPackage: 3,
    name: 'Pro',
    subTitle: `Broadcast aman, <br/> 
WhatsApp Business API`,
    price: '299.000',
    point: [
      { text: 'Semua fitur <span class="bg-gradient-to-r from-[#FFF701]  to-[#FFFFFF] bg-clip-text text-transparent">Komchat Basic</span>', active: true },
      // { text: 'Auto Save CRM ', active: true },
      { text: '1 Member Only', active: true },
      { text: '1,000 Percakapan Free (1 Bulan)', active: true },
      // { text: 'Dibantu Pengajuan Centang Biru', active: true },
      { text: 'Free Chat (72 Jam) <br/> <small>*Syarat & Ketentuan Berlaku</small>', active: true },
    ],
  },
]

export const FB_APP_KOMCHAT_ID = process.env.VUE_APP_FACEBOOK_KOMCHAT_APP_ID
export const FB_CONFIG_KOMCHAT_ID = process.env.VUE_APP_FACEBOOK_KOMCHAT_CONFIG_ID
